import { Service } from '@roc/feature-app-core';

const url = {
  TITLE_HISTORY_LOOKUP: '/api/v1/loan/titleHistoryLookup',
};

export class TitleHistoryLookupService extends Service {
  lookupTitleHistory(data: FormData) {
    return this.post(url.TITLE_HISTORY_LOOKUP, data);
  }
}
